import React from "react"
import {
  Grid, Typography, Box, Button, TextField, Checkbox, FormControlLabel,
  Dialog, DialogTitle, DialogContent, DialogActions, Divider,
  List, ListItem, ListItemText, Snackbar, CircularProgress
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { CompanyContext } from "../../context/CompanyContext";
import { FormContext } from "../../context/FormContext";
import { OrderContext } from '../../context/OrderContext';
import { useSubscriber } from '../../context/SubscribersContext';
import { ManagerContext } from '../../context/ManagerContext';
import { useEvent } from '../../context/EventContext';
import { api } from '../../services/api'

export default function FinsihRegistration() {
  const { company } = React.useContext(CompanyContext);
  const { order, setOrder } = React.useContext(OrderContext)
  const { manager } = React.useContext(ManagerContext);
  const { activeStep, setActiveStep } = React.useContext(FormContext);
  const { subscriber, setSubscriber } = useSubscriber()
  const [loading, setLoading] = React.useState(false)
  const { events, setEvents } = useEvent()
  const [stateAlert, setStateAlert] = React.useState({ status: false, type: 'success', msg: '' });
  const [acceptPolicy, setAcceptPolicy] = React.useState(false);
  const [openPolicy, setOpenPolicy] = React.useState(false);
  const [policyType, setPolicyType] = React.useState('privacy'); // 'privacy' ou 'subscription'



  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const total = order.hosting == 'NoHosting' ? order.plan_price * order.quantity : (order.plan_price + (order.pricebyday * order.daily)) * order.quantity
  const host = events.hostings?.find(h => h.id === order.hosting)


  async function handleSubscription() {
    try {
      setLoading(true)
      const sendOrder = await api.post('/orders', {
        data: {
          event: order.event,
          company: order.company,
          plan: order.plan,
          plan_price: order.plan_price,
          subscribers: order.subscribers,
          quantity: order.quantity,
          payment_form: order.payment_form,
          hosting: order.hosting,
          daily: order.daily,
          checkin: order.checkin,
          checkout: order.checkout,
        }
      })
      if (Array.isArray(sendOrder.data)) {
        sendOrder.data.map(orderPayment => {
          console.log(orderPayment)
        })
        setOrder([{ ...order, payments: sendOrder.data }])
        setLoading(false)
        setActiveStep(activeStep + 1)
      } else {
        setOrder([{ ...order, payment_url: sendOrder.data?.payment_url }])
        setLoading(false)
        setActiveStep(activeStep + 1)
      }


    } catch (error) {
      console.log(error)
      setLoading(false)
      setStateAlert({ status: true, type: 'error', msg: `${error.response?.data?.error?.message || error.message}` })
    }

  }
  return (
    <React.Fragment>
      <Snackbar
        open={stateAlert.status}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={() => setStateAlert({ status: false, type: 'error', msg: '' })} >
        <Alert sx={{ width: '100%' }} severity={`${stateAlert.type}`}>
          {stateAlert.msg}
        </Alert>
      </Snackbar>
      <>
        {loading ?
          <Box sx={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center' }}>
            <CircularProgress sx={{ alignSelf: 'center' }} size={100} />
          </Box>
          :
          <>
            <Typography sx={{ textAlign: 'center' }} variant="h6">Instituição Pagadora </Typography>
            <Grid container spacing={2} mt={2} mb={2} columns={12}>
              <Grid item xs={12} md={8}>
                <TextField
                  id="social_reason"
                  label="Razão Social"
                  fullWidth
                  variant="outlined"
                  name="social_reason"
                  disabled
                  value={company.social_reason}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="cnpj"
                  label="CNPJ"
                  fullWidth
                  variant="outlined"
                  name="cnpj"
                  disabled
                  value={company.document}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  id="trade"
                  label="Nome Fantasia"
                  fullWidth
                  variant="outlined"
                  name="trade"
                  disabled
                  value={company.trade}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  id="email"
                  label="Email"
                  fullWidth
                  variant="outlined"
                  name="email"
                  disabled
                  value={company.email}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="cep"
                  label="CEP"
                  fullWidth
                  type={'tel'}
                  variant="outlined"
                  name="cep"
                  disabled
                  value={company.cep}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="address"
                  label="Endereço"
                  fullWidth
                  variant="outlined"
                  name="address"
                  disabled
                  InputLabelProps={{ shrink: true }}
                  value={company.address}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="number"
                  label="Número"
                  fullWidth
                  variant="outlined"
                  name="number"
                  InputLabelProps={{ shrink: true }}
                  value={company.number}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="complement"
                  label="Complemento"
                  fullWidth
                  variant="outlined"
                  name="complement"
                  InputLabelProps={{ shrink: true }}
                  disabled
                  value={company.complement}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="district"
                  label="Bairro"
                  fullWidth
                  variant="outlined"
                  name="district"
                  InputLabelProps={{ shrink: true }}
                  disabled
                  value={company.district}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="city"
                  label="Cidade"
                  fullWidth
                  variant="outlined"
                  name="city"
                  InputLabelProps={{ shrink: true }}
                  disabled
                  value={company.city}
                />
              </Grid>
              <Grid item xs={12} md={1}>
                <TextField
                  id="state"
                  label="Estado"
                  fullWidth
                  variant="outlined"
                  name="state"
                  InputLabelProps={{ shrink: true }}
                  value={company.state}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="phone"
                  label="Telefone"
                  type={'tel'}
                  fullWidth
                  variant="outlined"
                  name="phone"
                  disabled
                  value={company.phone}
                />
              </Grid>
            </Grid>
            <Typography sx={{ textAlign: 'center' }} variant="h6">Tipo de Inscrição </Typography>
            <Grid container spacing={2} mt={2} mb={2} columns={12}>
              <Grid item xs={12} md={12}>
                <TextField
                  id="type_subscription"
                  label="Tipo de Inscrição"
                  fullWidth
                  variant="outlined"
                  name="phone"
                  disabled
                  value={order.plan_describe}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  id="payment_form"
                  label="Forma de Pagamento"
                  fullWidth
                  variant="outlined"
                  name="payment_form"
                  disabled
                  value={order.payment_form}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="quantity"
                  label="Quantidade de Inscritos"
                  fullWidth
                  variant="outlined"
                  name="quantity"
                  disabled
                  value={order.quantity}
                />
              </Grid>
            </Grid>
            <Typography sx={{ textAlign: 'center' }} variant="h6">Inscritos</Typography>
            <Grid container spacing={2} mt={2} mb={2} columns={12}>
              {subscriber.map((sub, index) => {
                return (
                  <>
                    <Grid key={index} item xs={12} md={2}>
                      <TextField
                        variant="outlined"
                        label="Nome Completo"
                        name="nome"
                        fullWidth
                        value={sub.name}
                        disabled
                      />
                    </Grid>
                    <Grid key={index} item xs={12} md={1}>
                      <TextField
                        variant="outlined"
                        label="Nome p/ Cracha"
                        name="badge"
                        fullWidth
                        value={sub.badge}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={1.5}>
                      <TextField
                        variant="outlined"
                        label={sub.isPassport ? "Passaporte" : "CPF"}
                        name="document"
                        fullWidth
                        value={sub.document}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        variant="outlined"
                        label="Email"
                        name="email"
                        fullWidth
                        value={sub.email}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={1.5}>
                      <TextField
                        variant="outlined"
                        label="Data de Nascimento"
                        name="birth"
                        fullWidth
                        type="date"
                        value={sub.birth}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={1}>
                      <TextField
                        variant="outlined"
                        label="Gênero"
                        name="gender"
                        fullWidth
                        type="text"
                        value={sub.gender}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={events.tshirtSize ? 1 : 2}>
                      <TextField
                        variant="outlined"
                        label="Whatsapp"
                        name="whatsapp"
                        fullWidth
                        value={sub.whatsapp}
                        disabled
                      />
                    </Grid>
                    {events.tshirtSize &&
                      <Grid item xs={12} md={1}>
                        <TextField
                          variant="outlined"
                          label="Tamanho Camiseta"
                          name="tshirtSize"
                          fullWidth
                          value={sub.tshirtSize}
                          disabled
                        />
                      </Grid>
                    }
                    <Grid item xs={12} md={1}>
                      <TextField
                        variant="outlined"
                        label="Cargo"
                        name="office"
                        fullWidth
                        value={sub.office}
                        disabled
                      />
                    </Grid>
                  </>
                )
              }
              )}
            </Grid>
            {order.hosting !== 'NoHosting' &&
              <>
                <Typography sx={{ textAlign: 'center' }} variant="h6">Hospedagem</Typography>
                <Grid container spacing={2} mt={2} mb={2} columns={12}>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="hosting"
                      label="Hospedagem"
                      fullWidth
                      variant="outlined"
                      name="hosting"
                      disabled
                      value={`${host.name} ${host.type}` || ''}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      id="diaria"
                      label="Diaria"
                      fullWidth
                      variant="outlined"
                      name="diaria"
                      disabled
                      value={order.daily || ''}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      id="diaria"
                      label="Valor por diaria"
                      fullWidth
                      variant="outlined"
                      name="diaria"
                      disabled
                      value={Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(host.pricebyday) || ''}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="totalpordiaria"
                      label="Valor Total das diarias"
                      fullWidth
                      variant="outlined"
                      name="totalpordiaria"
                      disabled
                      value={Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(host.pricebyday * order.daily) || ''}
                    />
                  </Grid>
                </Grid>
              </>
            }
            <Typography sx={{ textAlign: 'center' }} variant="h6">Total </Typography>
            <Grid container spacing={2} mt={2} mb={2} columns={12}>
              <Grid item xs={12} md={4}>
                <TextField
                  id="quantity"
                  label="Quantidade de Inscritos"
                  fullWidth
                  variant="outlined"
                  name="quatity"
                  disabled
                  value={order.quantity}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="price"
                  label="Valor por Inscrito"
                  fullWidth
                  variant="outlined"
                  name="price"
                  disabled
                  value={`R$ ${order.plan_price + (order.pricebyday * order.daily)}`}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="total"
                  label="Valor Total"
                  fullWidth
                  variant="outlined"
                  name="total"
                  disabled
                  value={`R$ ${total}`}
                />
              </Grid>
            </Grid>
          </>
        }
      </>
      {(manager?.fantasy === 'APEPREV' || manager?.fantasy === 'AGIP') && (
        <FormControlLabel
          control={
            <Checkbox
              checked={acceptPolicy}
              onChange={e => setAcceptPolicy(e.target.checked)}
              color="primary"
            />
          }
          label={
            <span>
              Li e aceito a{' '}
              <a
                href="#"
                style={{ textDecoration: 'underline', color: '#1976d2', cursor: 'pointer' }}
                onClick={e => {
                  e.preventDefault();
                  setPolicyType('privacy');
                  setOpenPolicy(true);
                }}
              >
                Política de Privacidade
              </a>
              {manager?.fantasy === 'AGIP' && (
                <>
                  {' '}e a{' '}
                  <a
                    href="#"
                    style={{ textDecoration: 'underline', color: '#1976d2', cursor: 'pointer' }}
                    onClick={e => {
                      e.preventDefault();
                      setPolicyType('subscription');
                      setOpenPolicy(true);
                    }}
                  >
                    Política de Inscrições
                  </a>
                </>
              )}
              {' '}e o uso dos meus dados.
            </span>
          }
        />
      )}
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          variant="contained"
          type={'button'}
          color='warning'
          disabled={loading}
          onClick={() => setActiveStep(activeStep - 1)}
          sx={{ mt: 3, mr: 1 }}>
          Voltar
        </Button>
        <Button
          variant="contained"
          type={'submit'}
          color='success'
          disabled={loading || ((manager?.fantasy === 'APEPREV' || manager?.fantasy === 'AGIP') && !acceptPolicy)}
          onClick={() => handleSubscription()}
          sx={{ mt: 3, mr: 1 }}>
          {loading ? 'Realizando Inscrição' : 'Realizar Inscrição'}
        </Button>
      </Box>
      <Dialog open={openPolicy} onClose={() => setOpenPolicy(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ fontWeight: 700, fontSize: 22 }}>
          {policyType === 'privacy' ? 'Política de Privacidade' : 'Política de Inscrições'}
        </DialogTitle>
        <DialogContent dividers sx={{ maxHeight: 600 }}>
          {manager?.fantasy === 'APEPREV' && policyType === 'privacy' ? (
            // Conteúdo específico da APEPREV (mantém o atual)
            <>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Data de atualização: 05/03/2025
              </Typography>
              <Typography paragraph>
                A APEPREV sabe o quão importante são a segurança e a privacidade de informações dos usuários dos seus serviços, por isso, adota as medidas necessárias para protegê-las.
              </Typography>
              <Typography paragraph>
                Esta Política de Privacidade apresenta como coletamos, compartilhamos e utilizamos seus Dados Pessoais e como você poderá exercer seus direitos de privacidade, tornando transparente o compromisso da APEPREV com a proteção das informações dos participantes dos eventos.
              </Typography>
              <Typography paragraph>
                Recomendamos que você leia esta Política de Privacidade por completo para garantir que esteja totalmente informado e compreenda os termos apresentados. Ao confirmar a sua inscrição no evento, você declara-se ciente e que concorda com esta presente Política.
              </Typography>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom>1. Dados pessoais que coletamos</Typography>
              <Typography paragraph>
                Assumimos o compromisso de coletar apenas os dados mínimos e necessários para efetivar sua participação nos eventos da APEPREV, o que inclui informações que possam ajudar na resolução de problemas e melhoria do serviço.
              </Typography>
              <Typography paragraph>
                Para permitir a correta identificação dos participantes de um evento, são necessários coletar alguns dados pessoais como nome, e-mail, gênero, CPF, endereço e data de nascimento. Essas informações serão fornecidas por você no formulário de inscrição do evento.
              </Typography>
              <Typography paragraph>
                Ao se inscrever em um determinado evento, outros dados serão solicitados como cargo e instituição para permitir a sua identificação e confecção de crachás de acesso.
              </Typography>
              <Typography paragraph>
                É importante esclarecer que quando pedimos algum dado pessoal, você tem a opção de recusar. Entretanto, o fornecimento é mandatório para a inscrição no evento e, caso não ocorra, não será possível efetivar a sua inscrição. É importante observar que, na necessidade de cumprir algum requisito legal ou ordem judicial, pode não ser viável a exclusão dos dados. Nesses casos, a APEPREV se compromete a reter os dados apenas para o cumprimento das disposições legais aplicáveis.
              </Typography>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom>2. Como utilizamos os seus dados</Typography>
              <Typography paragraph>
                Os dados coletados são utilizados para efetivar a sua inscrição em eventos da APEPREV e permitir que você tenha acesso à sua programação. De forma geral, seus dados podem ser utilizados para:
              </Typography>
              <List dense>
                <ListItem><ListItemText primary="• Envio de e-mails de confirmação da inscrição, material complementar, pesquisa de avaliação e outras informações;" /></ListItem>
                <ListItem><ListItemText primary="• Elaboração de listas de inscritos e presença;" /></ListItem>
                <ListItem><ListItemText primary="• Disponibilização de dados de inscritos aos patrocinadores e apoiadores institucionais;" /></ListItem>
                <ListItem><ListItemText primary="• Emissão de certificados de participação." /></ListItem>
              </List>
              <Typography paragraph>
                Seus dados serão armazenados por tempo indeterminado para permitir que você se inscreva facilmente em eventos futuros. Entretanto, você pode solicitar a exclusão dos seus dados a qualquer momento, através do envio da solicitação via e-mail para apeprev@apeprev.com.br.
              </Typography>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom>3. Com quem compartilhamos seus dados</Typography>
              <Typography paragraph>
                Os eventos da APEPREV contam com apoio de empresas e instituições que nos ajudam a fornecer uma infraestrutura e conteúdo de qualidade aos seus participantes. Uma contrapartida oferecida aos apoiadores consiste no envio da listagem de inscritos para contatos institucionais. A listagem de organizações apoiadoras está disponível na página inicial do evento.
              </Typography>
              <Typography paragraph>
                Nessas situações compartilharemos apenas nome, e-mail e instituição vinculada. Ao se inscrever em um evento da APEPREV, você nos autoriza a compartilhar essas informações com os nossos apoiadores.
              </Typography>
              <Typography paragraph>
                É importante observar que ao se inscrever em um determinado evento, o compartilhamento ocorrerá exclusivamente com os fornecedores do evento em questão.
              </Typography>
              <Typography paragraph>
                Todos os nossos parceiros e fornecedores estão em conformidade com as boas práticas para a segurança de dados pessoais e orientados, em contratos e outros instrumentos aplicáveis, a utilizar os dados apenas para os fins especificados e de acordo com as instruções da APEPREV.
              </Typography>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom>4. Seus direitos de proteção de dados pessoais</Typography>
              <Typography paragraph>
                A APEPREV está comprometida na proteção de seus dados pessoais e adota as medidas necessárias para garantir a segurança, integridade e confiabilidade dos dados pessoais.
              </Typography>
              <Typography paragraph>
                Você pode solicitar a exclusão dos seus dados através do e-mail apeprev@apeprev.com.br. Receberemos a solicitação e, caso não haja algum empecilho legal, procederemos com a remoção de seus dados. É importante observar que, neste caso, você não conseguirá mais participar do evento.
              </Typography>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom>5. Uso de imagem</Typography>
              <Typography paragraph>
                Durante a realização de um determinado evento, podem ser realizadas filmagens e fotografias para publicação nas páginas e redes sociais da APEPREV. Desse modo, os inscritos declaram-se cientes que sua imagem e voz poderão ser exibidas parcial ou totalmente em apresentações audiovisuais, publicações em redes sociais e divulgações em páginas da Internet.
              </Typography>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom>6. Envio de e-mail marketing</Typography>
              <Typography paragraph>
                Você poderá, a qualquer momento, solicitar a exclusão de seus dados da base de e-mail marketing da APEPREV, através do link fornecido ao final de uma mensagem enviada.
              </Typography>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom>7. Mudanças na política</Typography>
              <Typography paragraph>
                A APEPREV comunicará, por e-mail e pelo site, aos inscritos qualquer mudança nos termos dessa Política de Privacidade. Você poderá revogar o consentimento no uso de seus dados, caso discorde das alterações.
              </Typography>

              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom>8. Fale conosco</Typography>
              <Typography paragraph>
                Se você tiver dúvidas, sugestões ou preocupações sobre o uso de seus Dados Pessoais, entre em contato via e-mail: <b><a
                  href="mailto:apeprev@apeprev.com.br"
                  style={{ textDecoration: 'underline', color: '#1976d2', cursor: 'pointer' }}>apeprev@apeprev.com.br</a></b>.
              </Typography>
            </>
          ) : (
            // Conteúdo dinâmico do manager para AGIP ou outros
            <Box
              sx={{
                '& p': { mb: 2, textAlign: 'justify' },
                '& h1, & h2, & h3, & h4, & h5, & h6': {
                  color: '#1D385E',
                  mt: 3,
                  mb: 2
                },
                '& ul, & ol': {
                  pl: 3,
                  mb: 2
                },
                '& li': {
                  mb: 1
                }
              }}
              dangerouslySetInnerHTML={{
                __html: policyType === 'privacy'
                  ? (manager?.privatePolicy || '<p>Política de Privacidade não disponível.</p>')
                  : (manager?.subscriberPolicy || '<p>Política de Inscrições não disponível.</p>')
              }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPolicy(false)} variant="contained" color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>)
}